module.exports = __webpack_public_path__ + "assets/images/animations/enqsta-animation.webp?58c31f61";